import {inject, Injectable} from '@angular/core';
import {Color, Invitation, Message, Room, UserImage} from '@models';
import {MessageService} from './message.service';
import {ProfileService} from '../community';

@Injectable()
export class TchatService {
	public chat = [];
	public notifMap: Map<string, boolean>;
	public invitSet: Set<Invitation>;
	public colors: Color[] = [
		{
			name: 'Regular',
			cssCode: '#e8e8e8',
			premium: false
		},
		{
			name: 'Cherry',
			cssCode: '#d80628',
			premium: false
		},
		{
			name: 'Orange Juice',
			cssCode: '#fe8956',
			premium: false
		},
		{
			name: 'Lemon',
			cssCode: '#ffff5d',
			premium: false
		},
		{
			name: 'Apple',
			cssCode: '#00ff7f',
			premium: false
		}
		,
		{
			name: 'Ocean',
			cssCode: '#07f',
			premium: false
		},
		{
			name: 'Bubblegum',
			cssCode: '#ff76c1',
			premium: true
		},
		{
			name: 'Gold',
			cssCode: '#b9831e',
			premium: true
		},
		{
			name: 'Mirabelle',
			cssCode: '#cebc17',
			premium: true
		},
		{
			name: 'Banana',
			cssCode: '#fdfda1',
			premium: true
		},
		{
			name: 'Praline',
			cssCode: '#bc8f8f',
			premium: true
		},
		{
			name: 'Berry',
			cssCode: '#ae3c58',
			premium: true
		},
		{
			name: 'Peach',
			cssCode: '#ff4e66',
			premium: true
		},
		{
			name: 'Mauve',
			cssCode: '#de42f3',
			premium: true
		},
		{
			name: 'Blush',
			cssCode: '#ffb1fc',
			premium: true
		},
		{
			name: 'Plum',
			cssCode: '#6D577F ',
			premium: true
		},
		{
			name: 'Wine',
			cssCode: '#7219b7',
			premium: true
		},
		{
			name: 'Purple Haze',
			cssCode: '#9247ff',
			premium: true
		},
		{
			name: 'Lilac',
			cssCode: '#b47ffe',
			premium: true
		},
		{
			name: 'Indigo',
			cssCode: '#595feb',
			premium: true
		},
		{
			name: 'Sky',
			cssCode: '#51bfff',
			premium: true
		},
		{
			name: 'Cyan',
			cssCode: '#03ffea',
			premium: true
		},
		{
			name: 'IceCube',
			cssCode: '#afeeee',
			premium: true
		},
		{
			name: 'Outremer',
			cssCode: '#017977',
			premium: true
		},

		{
			name: 'Army',
			cssCode: '#47a247',
			premium: true
		},
		{
			name: 'Lime',
			cssCode: '#9f3',
			premium: true
		},
		{
			name: 'Mint',
			cssCode: '#7ef5b1',
			premium: true
		}
	];

	private messageService;
	private profileService;

	constructor() {
		this.profileService = inject(ProfileService);
		this.messageService = inject(MessageService);
		this.notifMap = new Map<string, boolean>();
		this.invitSet = new Set<Invitation>();
	}

	getColors(): Color[] {
		return this.colors;
	}

	addImageMessage(image: UserImage, room: Room) {
		return room.sendMessage(new Message({
			                                    content: null,
			                                    sender: this.profileService.currentUid,
			                                    createdAt: Date.now(),
			                                    isImage: true,
			                                    fileUrl: image.url
		                                    }), this.messageService);
	}

	addGifMessage(gif: string, room: Room) {
		return room.sendMessage(new Message({
			                                    content: null,
			                                    sender: this.profileService.currentUid,
			                                    createdAt: Date.now(),
			                                    isImage: true,
			                                    fileUrl: gif
		                                    }), this.messageService);
	}
}
